<template>
  <div class="mainContent db-page">
    <div class="top-control">
      <div class="tab-content">
        <div class="dashboard-hpo" v-if="renderComponent">
          <muuri-grid id="grid" ref="muurigrid" :options="{dragEnabled: false}">
            <!-- <muuri-grid-item width="100%">
                <three-month-report></three-month-report>
            </muuri-grid-item>
            <muuri-grid-item width="100%">
                <sale-monthly-report></sale-monthly-report>
            </muuri-grid-item> -->
            <!-- <muuri-grid-item width="100%">
                <sale-warning-report></sale-warning-report>
            </muuri-grid-item> -->
            <muuri-grid-item width="100%">
                <debt-summary></debt-summary>
            </muuri-grid-item>
          </muuri-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configs from '@/configs';
import clickoutside from '@/directives/clickoutside';
// import ThreeMonthReport from '@/components/dashboard/ThreeMonthReport';
// import SaleMonthlyReport from '@/components/dashboard/SaleMonthlyReport';
// import SaleWarningReport from '@/components/dashboard/SaleWarningReport';
import DebtSummary from '@/components/dashboard/DebtSummary';
import { MuuriGridItem } from 'vue-muuri-grid';

export default {
  directives: { clickoutside },
  components:{
    // 'three-month-report': ThreeMonthReport,
    // 'sale-monthly-report': SaleMonthlyReport,
    // 'sale-warning-report': SaleWarningReport,
    'debt-summary': DebtSummary,
    MuuriGridItem,
  },
  data() {
    return {
      showModal: false,
      renderComponent: true,
      popupModalName: '',
      popupModalTitle: '',
      popupModalHeight: 600,
    }
  },
  mounted() {
    this.$root.$on('zoomChart', (widget) => {
    this.popupModalName = widget.widgetName;
    this.popupModalTitle = widget.widgetTitle;
    this.popupModalHeight = window.innerHeight * 0.6;
    });
  }
}
</script>
<style>
.modal-open{padding-right: 0 !important; }
.modal-backdrop{ z-index: 999998;}
.close:focus{outline:none}
</style>